import { ColumnData, GroupRule, RulesConfig } from 'components/dataset-viewer';
export type { FilterData, ColumnData, RulesConfig, DatasetDataResponse } from 'components/dataset-viewer';
export { getInitialFilterState } from 'components/dataset-viewer';

function collectRuleKeys(group: GroupRule): Set<string> {
    const keys = new Set<string>();
    for (const rule of group.rules) {
        if (rule.group) {
            collectRuleKeys(rule.group).forEach((k) => keys.add(k));
        }
        if (rule.key) {
            keys.add(rule.key);
        }
    }
    return keys;
}

export function buildDisplayTemplateSuggestion(
    ruleName: string,
    columnsData: ColumnData[],
    filter: RulesConfig,
): string {
    const ruleKeys = collectRuleKeys(filter.group);
    const selectedFields = new Set(filter.resultFields);
    const textFields = columnsData.filter((col) => {
        if (col.value_type !== 'text') return false;
        if (!selectedFields.has(col.id)) return false;
        const colKey = `${col.id.replaceAll(' ', '_')}-current`;
        return !ruleKeys.has(colKey);
    });
    if (textFields.length === 0) {
        return ruleName;
    }
    return `${ruleName} for ${textFields.map((col) => `[${col.column_name}]`).join(', ')}`;
}
